import React from 'react';
import { Box, IconButton } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { BrandButton, ErrorOutlinedButton } from '../button';

const CampaignListToolbar = ({
  viewMode,
  onViewModeChange,
  selectedCount = 0,
  onDeleteSelected,
  onExport,
  exportLabel = 'Export',
  children,
  inline = false,
}) => (
  <Box
    display="flex"
    justifyContent="flex-end"
    alignItems="center"
    mb={inline ? 0 : 2}
    flexWrap="wrap"
    gap={1}
  >
    {children}
    <IconButton onClick={() => onViewModeChange('visual')} aria-label="grid view">
      <GridViewIcon color={viewMode === 'visual' ? 'primary' : 'inherit'} />
    </IconButton>
    <IconButton onClick={() => onViewModeChange('table')} aria-label="table view">
      <TableRowsIcon color={viewMode === 'table' ? 'primary' : 'inherit'} />
    </IconButton>
    {selectedCount > 0 && onDeleteSelected && (
      <ErrorOutlinedButton onClick={onDeleteSelected} sx={{ ml: 1 }}>
        DELETE
      </ErrorOutlinedButton>
    )}
    {onExport && (
      <BrandButton onClick={onExport} sx={{ ml: 1 }}>
        {exportLabel}
      </BrandButton>
    )}
  </Box>
);

export default CampaignListToolbar;
